export default {
  en: 'English',
  cn: '简体中文',
  vn: 'Tiếng Việt',
  ru: 'Pусский',
  // tw: '繁體中文',
  kr: '한국어',
  // ru: 'Русский',
  // es: 'Español',
  // fr: 'Français',
  // de: 'Deutsch',
  // tr: 'Türkçe',
  // nl: 'Nederlands',
  // pt: 'Português',
  // it: 'Italiano',
  // pl: 'Polski',
  // id: 'Indonesian',
  // ph: 'Pilipino',
  uk: 'Українська'
}
